
import {Component, Vue} from 'vue-property-decorator';
import {ImportType} from '@/data/models/enums/import-type-enum';

/** Onglet « Relancer un import » : import manuel d'un type de source sur une période. */
@Component({})
export default class AdminRestartImport extends Vue {
  startDate: string = null;
  endDate: string = null;
  importTypesList: Array<{ label: string, value: string }> = Object.keys(ImportType).map((key) => ({label: ImportType[key], value: key}));
  selectedImportType: { label: string, value: string } = null;
  starting = false;

  startImport(): void {
    this.starting = true;
    this.$dao.logs.startImport(this.selectedImportType.value as ImportType, this.startDate, this.endDate).then(() => {
      this.$dialog.notify.success('Import relancé avec succès');
    }).catch(() => {
      this.$dialog.error({text: 'Une erreur est survenue', title: 'Erreur'});
    }).finally(() => this.starting = false);
  }
}
